import * as Sentry from '@sentry/vue';
import { Constants } from '@/constants';
import { type App } from 'vue';

const initSentry = (app: App) => {
	const isSentryEnabled = Boolean(document.getElementById('isSentryEnabled'));

	if (!isSentryEnabled) {
		return;
	}

	Sentry.init({
		dsn: Constants.SENTRY.DSN,
		release: `scoro@${
			(<HTMLInputElement>document.getElementById('versionNumber'))?.value
		}`,
		integrations: function (integrations) {
			return integrations.filter(function (integration) {
				return integration.name !== 'Breadcrumbs';
			});
		},
		app,
		/**
		 * A global error sample rate to apply.
		 * 0.0 = 0% chance of a given event being sent (send no events) 1.0 = 100% chance of a given event being sent (send all events)
		 * */
		sampleRate: 1.0,
		sendClientReports: false,
		ignoreErrors: [
			'ResizeObserver loop limit exceeded', // ResizeObserver was not able to deliver all observations within a single animation frame
			'ResizeObserver loop completed with undelivered notifications.',
			'NS_ERROR_UNEXPECTED', // Generic Firefox error triggered by a timing or race condition
			/Unable to preload CSS/, // Most likely user network related
			'NetworkError when attempting to fetch resource.', // Most likely user network related
			'ApolloError: Load failed',
			'Failed to fetch', // Most likely caused by user network issues
			"Cannot read properties of null (reading 'emitsOptions')", // Error with teleport component
			'Internal error opening backing store for indexedDB.open', // vue3 emoji uses idb which can throw this error,
			'UnknownError: Internal error.', // Possible 3rd party errors
		],
		denyUrls: [
			// Chrome extensions
			/^chrome:\/\//i,
			// Usetiful errors
			/^https:\/\/www\.usetiful\.com\//i,
			/tinymce\/tinymce\//i,
			// Tracking-related
			/https?:\/\/[^\/]*(amplitude|planhat)/i,
		],
	});
};

export default initSentry;
